import BaseListPresenter from "../../../../../base/BaseListPresenter";

class UserLogsPresenter extends BaseListPresenter {
  constructor(view, findObjectUseCase, countObjectUseCase, upsertUseCase, deleteObjectUseCase) {
    super(view, findObjectUseCase, countObjectUseCase, upsertUseCase, deleteObjectUseCase);
  }

  init() {
    const { id } = this.view.getParams();
    this.limit = 20;
    this.where = { user: { id } };
    this.search = {};
    this.filter = {};
    this.include = [];
    this.keys = undefined;
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }
}

export default UserLogsPresenter;
